import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';

import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';
import { commandWorkspaceDeploymentsList } from '../actions';

export function* sendRequest(connection, action) {
  const { activityId, cohortId, deploymentId } = action;

  const workspaceActivityPublish = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_ACTIVITY_PUBLISH,
    activityId,
    cohortId,
    deploymentId,
  });

  if (workspaceActivityPublish.type !== constants.RTM_WORKSPACE_ACTIVITY_PUBLISH_OK) {
    yield put(
      pushToast({
        type: 'simple',
        message: workspaceActivityPublish.message || <FormattedMessage {...messages.failedWorkspaceActivityPublish} />,
      })
    );
  } else {
    /* Backend doesnt return a deployment DTO, so we update
     * the store by refetching the entire deployment list
     * for the cohort
     */
    yield put(commandWorkspaceDeploymentsList(cohortId));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_ACTIVITY_PUBLISH, catchErrors, sendRequest, connection);
}
